import '~style/blocks/logo-ribbon/index.scss';
import ContinuousLogoCarousel from '~scripts/component/continuous-logo-carousel';

ContinuousLogoCarousel.init();
